import './ResolveConflicts.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ACDLVirtualGrid } from '../../../../../../../../__legacy__/components/virtuals/ACDLVirtualGrid';
import { S_ConfirmationModal } from '../../../../../../../../design/modals/confirmationModal/S_ConfirmationModal';
import { RowLayout } from '../../../../../../../common/layouts/rowLayout/RowLayout';
import { ImportAnnotationConflict } from '../../../models/ImportAnnotationsConflicts';
import { ResolveConflictTileContainer } from './resolveConflictsTile/ResolveConflictsTile.container';

interface Props {
  show: boolean;
  conflicts: ImportAnnotationConflict[];
  onHide: () => void;
  onSubmit: () => Promise<void>;
  keepAll: () => void;
  replaceAll: () => void;
}

export const ResolveConflictsStepModal = observer((props: Props): ReactElement => {
  const { t } = useTranslator();
  const { show, conflicts, onHide, onSubmit, keepAll, replaceAll } = props;
  const itemBuilder = (conflict: ImportAnnotationConflict): ReactElement => (
    <ResolveConflictTileContainer
      key={`${conflict.dataSetName}/${conflict.imageName}`}
      conflict={conflict}
    />
  );

  return (
    <S_ConfirmationModal
      cancelText={t('new.projects.details.import_annotations.cancel')}
      headerText={`${t('new.projects.details.import_annotations.header')} - ${t('new.projects.details.import_annotations.steps.resolve_conflicts.header')}`}
      submitText={t('new.projects.details.import_annotations.next')}
      onCancel={onHide}
      toggle={onHide}
      onSubmit={onSubmit}
      isOpen={show}
    >
      <div className='resolve-conflicts-container'>
        <p>{t('new.projects.details.import_annotations.steps.resolve_conflicts.decide_how_to_resolve_conflicts')}:</p>
        <RowLayout
          size='sm'
          className='resolve-conflict-buttons'
        >
          <Button
            variant='outlined'
            onClick={keepAll}
          >
            {t('new.projects.details.import_annotations.steps.resolve_conflicts.keep_all')}
          </Button>
          <Button
            variant='outlined'
            onClick={replaceAll}
          >
            {t('new.projects.details.import_annotations.steps.resolve_conflicts.replace_all')}
          </Button>
        </RowLayout>
        <div className='resolve-conflict-list'>
          <ACDLVirtualGrid<ImportAnnotationConflict>
            crossAxesCount={1}
            itemHeight={69}
            items={conflicts}
            itemBuilder={itemBuilder}
          />
        </div>
      </div>
    </S_ConfirmationModal>
  );
});
